<div class="form-check form-switch">
  <input
    [id]="options().id"
    class="form-check-input"
    type="checkbox"
    [value]="options().value"
    id="checkNativeSwitch"
    [checked]="options().value && true"
    (input)="onInput(switchEl)"
    [disabled]="options().disabled"
    switch
    #switchEl
  />
  <label
    class="form-label"
    for="checkNativeSwitch"
  >
    {{ translations[options().label?.text || 'label'] || options().label?.text }}
  </label>
</div>
